module.exports = {"environment_name":"production","api_base_url":"https://api.kungfood.co.uk/api/fe/","base_url":"https://api.kungfood.co.uk","sentry":"https://444a1b1ddbd34fc28e0ca1c05983e73c@sentry.io/1326248","stripe_token_location_1":"pk_live_6ZeQkjGQb39b6yiIKIKzYhM8","stripe_token_location_2":"pk_live_9dL7AVTlLgp0tUDBii8VAWxt","wallet_enabled":true}


//////////////////
// WEBPACK FOOTER
// ./src/env.json
// module id = 56
// module chunks = 1